
import Vue from 'vue';
import CardCaption from './CardCaption.vue';
import NotesCardSkeleton from '../skeletons/NotesCardSkeleton.vue';
import { Icon, Button } from '@descomplica/vue-components';
import { NoteModel } from '@/models/student-notes/note.model';

interface Data {
  showSkeleton: boolean;
}

export default Vue.extend({
  components: {
    CardCaption,
    NotesCardSkeleton,
    Icon,
    Button,
  },
  props: {
    notes: {
      type: Array as Vue.PropType<NoteModel[]>,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
  data(): Data {
    return {
      showSkeleton: true,
    };
  },
  watch: {
    isLoading: {
      immediate: true,
      handler(newValue) {
        this.showSkeleton = newValue;
      },
    },
  },
  methods: {
    goToNotebooks(): void {
      this.$router.push({
        name: 'notebooks',
      });
    },
  },
});
